'use strict';

export default class StylesItem {
	constructor(options) {
		options = options || {};

		Object.defineProperty(this, 'class', {
			writable: true,
			enumerable: true,
			value: options.class || '',
		});
		Object.defineProperty(this, 'name', {
			writable: true,
			enumerable: true,
			value: options.name || '',
		});
		Object.defineProperty(this, 'tags', {
			writable: true,
			enumerable: true,
			value: options.tags || [],
		});
		Object.defineProperty(this, '__type', {
			writable: true,
			enumerable: true,
			value: 'mx.designer.StylesItem',
		});
	}

	toString() {
		return this.class;
	}
}
